
import emailjs from "@emailjs/browser"
import { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert } from "react-bootstrap"
import { faPaperPlane, faRocket } from "@fortawesome/free-solid-svg-icons";
const ContactUsForm = ({handleClose}) => {
    const [successStat, setSuccessStat] = useState(false)
    const sendEmail = (e) => {
        e.preventDefault()
        emailjs.sendForm(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLETE_ID, e.target, process.env.REACT_APP_PUBLIC_KEY)
        .then(() => setSuccessStat(true))
        .catch(err => console.err("Error", err))
    }

    useEffect(() => {
        setSuccessStat(false)
    },[])

    return (
        <>
        {(successStat) ? 
        <Alert variant="success" onClose={handleClose} dismissible className="p-4">
            <Alert.Heading className="py-4">Thank you.</Alert.Heading>
            <p> You have successfully submitted the query form. </p>
            <p> Paracosma team will contact you shortly. </p> 
        </Alert>
        : 
            <div className="row p-3 m-3">
                <div className="col-lg-10 mx-auto">
                    <h1 className="font-weight-light text-center mt-2 fw-bolder">Contact Us</h1>
                    <p className=" m-0 ">We welcome your inquiries! Please use the space below to share your message, along with your contact information and interests. Our team is committed to swift responses. Thank you for getting in touch!</p>
                    <form className="mt-4" onSubmit={sendEmail}>
                        <div className="row card p-2 ">
                        <div className="col-lg-12">
                                <div className="form-group mt-2">
                                    <input className="form-control" name="name" type="text"  placeholder="Your Name" />
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="form-group mt-2">
                                    
                                    <input className="form-control" name="phone" type="tel"  placeholder="Phone Number" />
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="form-group mt-2">
                                    
                                    <input className="form-control" name="company_name" type="text"  placeholder="Company Name" />
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="form-group mt-2">
                                    
                                    <input className="form-control" name="email" type="text"  placeholder="Email" />
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="form-group mt-2">
                                    
                                    <textarea className="form-control" name="message" rows="3" placeholder="Type your message here"></textarea>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <button type="submit" className="btn btn-primary mt-3 w-100 text-white  border-0 px-3 py-2"><FontAwesomeIcon icon={faPaperPlane} className="px-2 mx-2 icon-color-font"/> SEND</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
                    
        }
            
             {/* <h1 className="page__title">Contact Us</h1>
             
            <form className="contact__form">
                <label htmlFor="emailFrom">Email:</label>
                <input type="text" name="email_from" id="emailFrom" className="email__from" placeholder="person@example.com"/>
                <label htmlFor="message">Message:</label>
                <textarea name="message" id="message" className="message__box"></textarea>
                <Button variant="contained" className="submit__btn" style={{marginTop: "5px"}}>
                Send
            </Button>
            </form> */}
        </>
    )
}

export default ContactUsForm